import api from '@/api'
import { jsFn } from '@/utils/jsFn'
const KEEPSTORAGE = 'KEEPSTORAGE'
const SETTOKEN = 'SETTOKEN'
const SETUSERINFO = 'SETUSERINFO'
const SETBENEFITS = 'SETBENEFITS'
const RESBENEFITS = 'RESBENEFITS'
const SETUSERSETTING = 'SETUSERSETTING'
const SETEVENTS = 'SETEVENTS'
const UPDEVENTS = 'UPDEVENTS'
const SETCOUPONS = 'SETCOUPONS'
const UPDCOUPONS = 'UPDCOUPONS'
const RESETSTATE = 'RESETSTATE'
const SETBASEEX = 'SETBASEEX'
const SETREFEFFALINFO = 'SETREFEFFALINFO'
const UPDISCHECKBX = 'UPDISCHECKBX'

const defaultState = () =>{
    return {
        tokens: {
            id_token: '',
            access_token: '',
            expires_in: '',
            token_type: '',
        },
        userInfo:{
            id: '',
            name: '',
            picture: ''
        },
        benifits:{
            "hiteach": [
                {
                    "func": "soklite",
                    "para": null,
                    "get": null,
                    "exp":null
                },
                {
                    "func": "aitext",
                    "para": null,
                    "get": null,
                    "exp": null
                }
            ],
        },
        usersetting:{
            isCheckBX2026: false,
            coupons: [],
            events:[]
        },
        referralInfo: {
            code: "",
            usage: 0
        },
        eventCouponIds: ['hiteach333', 'hiteach50'],
        baseEx: null,
        eventCoupons: [
            {
                type: "C", // 優惠券屬性 C: coupon, V: voucher
                code: "HITEACH50", // 優惠券號
                expire: 9999999999999,      // 到期時間
                isExchange: false,// 是否被兌換
                isExpired: false, // 是否已過期
                endTime: -1,      // 結束時間(包含兌換與過期時間，預計保留半年)
                title: "discovery_7",
                cont: "discovery_8",
                eventName: "hiteach50-1",
            },
            // {
            //     type: "C", // 優惠券屬性 C: coupon, V: voucher
            //     code: "SK30W10T", // 優惠券號
            //     expire: 1711900799000,      // 到期時間
            //     isExchange: false,// 是否被兌換
            //     isExpired: false, // 是否已過期
            //     endTime: -1,      // 結束時間(包含兌換與過期時間，預計保留半年)
            //     title: "discovery_10",
            //     cont: "discovery_11",
            //     eventName: "sk30w10t",
            // },
            {
                type: "C", // 優惠券屬性 C: coupon, V: voucher
                code: "AITEXT-2026", // 優惠券號 AI文句分析
                expire: 1803686400000,      // 到期時間
                isExchange: false,// 是否被兌換
                isExpired: false, // 是否已過期
                endTime: -1,      // 結束時間(包含兌換與過期時間，預計保留半年)
                title: "discovery_12",
                cont: "event2_text2",
                eventName: "aitext",
            },
            {
                type: "C", // 優惠券屬性 C: coupon, V: voucher
                code: "SOKLITE-2026", // 優惠券號 AI蘇格拉底小數據
                expire: 1803686400000,      // 到期時間
                isExchange: false,// 是否被兌換
                isExpired: false, // 是否已過期
                endTime: -1,      // 結束時間(包含兌換與過期時間，預計保留半年)
                title: "discovery_13",
                cont: "event2_text2",
                eventName: "soklite",
            },
        ]
    }
}

export default {
    namespaced: true,
    state: defaultState(),
    getters: {
        referralInfo: (state) => state.referralInfo,
        userInfo: (state) => state.userInfo,
        benifits: (state) => state.benifits,
        getBenifitsFunc: (state) => (type, func) => {
            return state.benifits[type]?.find(item => item.func === func)
        },
        events: (state) => state.usersetting.events,
        coupons: (state) => state.usersetting.coupons,
        isCheckBX: (state) => state.usersetting.isCheckBX2026,
        baseEx: (state) => state.baseEx,        
        tokens: (state) => state.tokens,
        eventCoupons: (state) => state.eventCoupons,
        getEvCoupon: (state) => (code) => {
            return state.eventCoupons.find(item => item.code === code)
        },
        baseEXCheckKey: () => {
            return ["name","unitType","unitName","jobTitle","country", "schoolCode"] // 需要被檢查的欄位
        }
    },
    mutations: {
        [KEEPSTORAGE](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state[key] = data[key]
            })
        },
        [SETTOKEN](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state.tokens[key] = data[key]
            })
        },
        [SETUSERINFO](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state.userInfo[key] = data[key]
            })
        },
        [SETBENEFITS](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state.benifits[key] = data[key]
            })

            // 檢測是否有指定的活動 沒有則增加預設值
            let result = state.benifits.hiteach.some(hit => hit.func == 'aitext');
            if(!result){
                state.benifits.hiteach.push({
                    "func": "aitext",
                    "para": null,
                    "get": null,
                    "exp":null
                })
            }

            result = state.benifits.hiteach.some(hit => hit.func == 'soklite');
            if(!result){
                state.benifits.hiteach.push({
                    "func": "soklite",
                    "para": null,
                    "get": null,
                    "exp":null
                })
            }
        },
        [RESBENEFITS](state) {
            state.benifits = {
                "hiteach": [
                    {
                        "func": "soklite",
                        "para": null,
                        "get": null,
                        "exp":null
                    },
                    {
                        "func": "aitext",
                        "para": null,
                        "get": null,
                        "exp": null
                    }
                ],
            }
        },
        [SETEVENTS](state, data) {
            state.usersetting.events.push(data)
        },
        [UPDISCHECKBX](state, data){
            state.usersetting.isCheckBX2026 = data
        },
        [UPDEVENTS](state, data) {
            state.usersetting.events.forEach((x, i)=>{
                if(x.name == data.name) {
                    state.usersetting.events.splice(i, 1, data)
                }
            })
        },
        [SETCOUPONS](state, data) {
            state.usersetting.coupons.push(data)
        },
        [UPDCOUPONS](state, data) {
            state.usersetting.coupons.forEach((x, i)=>{
                if(x.code == data.code) {
                    state.usersetting.coupons.splice(i, 1, data)
                }
            })
        },
        [SETUSERSETTING](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state.usersetting[key] = data[key]
            })
        },
        [RESETSTATE](state){
            const initState = defaultState()
            Object.keys(initState).forEach(key => {
                state[key] = initState[key]
            })
        },
        [SETBASEEX](state, data) {
            state.baseEx = data
        },
        [SETREFEFFALINFO](state, data) {
            state.referralInfo.code = data.referralCode
            state.referralInfo.usage = data.usage
        },
    },
    actions: {
        /** 
         * NOTE: Account 快速登入
         * @param {String} code
         * @return {String}
        */
        codeLogin(context, code) {
            return new Promise((resolve) => {
                api.coreApi.codeLogin(code).then(res => {
                    let tokens = {
                        id_token: res.id_token,
                        access_token: res.access_token,
                        expires_in: res.expires_in,
                        token_type: res.token_type
                    }
                    let tokenJWT = jsFn.jwtDecode(res.id_token)
                    let info = {
                        id: tokenJWT.sub,
                        name: tokenJWT.name,
                        picture: tokenJWT.picture
                    }
                    // 檢查活動完成資訊是否需要重置                    
                    if(info.id !== context.state.userInfo.id) {
                        context.commit(RESBENEFITS)
                    }
                    context.commit(SETTOKEN, tokens)
                    context.commit(SETUSERINFO, info)
                    context.dispatch('saveState') // 存到localstorage
                    resolve(true)
                }).catch(err => {
                    console.log(err)
                    resolve(false)
                })
            })
        },
        /**
         * NOTE: 取得個人資料
         * @return {Object}
         */
        async getUserInfo(context) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise(function(resolve, reject) {
                api.coreApi.getUserInfo(context.state.tokens).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * NOTE: 更新個人資訊API
         * @return {Object}
         */
        async tmdProfile(context, item) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise(function(resolve, reject) {
                api.coreApi.tmdProfile(context.state.tokens, item.grantType, item.name).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * NOTE: 取得個人進階聯絡資料
         * @return {Object}
         */
         async getUserContact(context) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise(function(resolve, reject) {
                api.coreApi.getContact(context.state.tokens).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * NOTE: 設定個人進階聯絡資料
         * @return {Object}
         */
        async setUserContact(context, item) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise(function(resolve, reject) {
                api.coreApi.setContact(context.state.tokens, item).then(res => {
                    if(res){
                        context.commit(SETBASEEX, item)
                        context.dispatch('saveState') // 存到localstorage
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * NOTE: 取得學校列表
         * @return {Object}
         */
        async getSchoolData(context, item) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise(function(resolve) {
                api.coreApi.getSchoolData(context.state.tokens, item).then(res => {
                    resolve(res)
                }).catch(() => {
                    resolve([])
                })
            })
        },
        /**
         * 取得優惠卷
         */
        async getCoupon(context, coupon) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.getCoupon(context.state.tokens, coupon).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * 兌換優惠券
         */
        async exchangeVoucher(context, voucher) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.exchangeVoucher(context.state.tokens, voucher).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /** 
         * NOTE: 取得使用者設定檔
         * @param {String} product
         * @return {Boolean}
        */
        async getUsersetting(context, product) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.getUsersetting(context.state.tokens, product).then( async(res) => {
                    switch (product){
                        case 'mynews':{
                            if(res.coupons) {
                                  res.coupons.forEach( (c, index) => {
                                    let today = new Date().getTime()
                                    if(c.expire.toString().length < 13) c.expire = c.expire * 1000

                                    // 檢查是否有過期票券
                                    if(today > c.expire){
                                        c.isExpired = true
                                        c.endTime = c.expire
                                    }

                                    // 檢查保存紀錄是否超過180天
                                    let diffDay = 180 // 超過此時間則刪除
                                    let diffDayTp = diffDay * 24 * 60 * 60 * 1000

                                    // 先避開雙AI券不刪
                                    if(c.endTime != -1 && (Math.abs(today - c.endTime) > diffDayTp)) {
                                        res.coupons.splice(index, 1);
                                    }
                                    
                                    if(c.info && c.info.length == 0) {
                                        if(!c.title) {
                                            let eCoupon = context.state.eventCoupons.filter(ec => ec.code == c.code)
                                            if(eCoupon.length > 0){
                                                c.title = eCoupon[0].title
                                                c.cont = eCoupon[0].cont
                                            }
                                        }
                                    }
                                })
                            }

                            // 檢查預設券
                            context.state.eventCoupons.forEach(c => {
                                let today = new Date().getTime()
                                if(c.expire.toString().length < 13) c.expire = c.expire * 1000

                                // 檢查是否有過期票券
                                if(today > c.expire){
                                    c.isExpired = true
                                    c.endTime = c.expire
                                }
                            })

                            let resulst = {
                                coupons: res.coupons ? res.coupons : [],
                                events: res.events ? res.events : [],
                                isCheckBX2026: res.isCheckBX2026 ? res.isCheckBX2026 : false
                            }
                            context.commit(SETUSERSETTING, resulst)
                            await context.dispatch('setUsersetting')
                        }
                        break
                        case 'benefits':
                            if(res.hiteach){
                                context.commit(SETBENEFITS, res)
                            }
                        break
                        case 'base-ex':
                            if(res){
                                context.commit(SETBASEEX, res)
                            }
                        break

                    }
                    context.dispatch('saveState') // 存到localstorage
                    resolve(true)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /** 
         * NOTE: 儲存使用者設定檔
         * @param {String} product
         * @return {Boolean}
        */
        async setUsersetting(context) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.setUsersetting(context.state.tokens, context.state.usersetting).then(() => {
                    context.dispatch('saveState') // 存到localstorage
                    resolve(true)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * NOTE: 儲存個人活動明細
         * @return {Boolean}
         */
        async setUserEvents(context, item) {
            let data = {
                "name": item.name,
                "steps": [
                    {
                        "step": item.step,
                        "done": item.done
                    }
                ]
            }
            context.commit(SETEVENTS, data)
        },
        /**
         * NOTE: 儲存個人活動明細
         * @return {Boolean}
         */ 
        async updUserEvents(context, item) {
            let data = context.state.usersetting.events.filter( y => y.name.toLocaleLowerCase() == item.name)

            let isExist = data[0].steps.some(x => x.step == item.step)

            if(isExist) {
                data[0].steps.forEach(x=>{
                    if(x.step == item.step){
                        x.done = item.done
                    }
                });
            } else {
                data[0].steps.push({
                    "step": item.step,
                    "done": item.done
                })
            }

            context.commit(UPDEVENTS, data[0])
        },
        /**
         * NOTE: 儲存個人活動明細
         * @return {Boolean}
         */ 
        async updIsCheckBX(context, item) {
            context.commit(UPDISCHECKBX, item)
        },

        /**
         * NOTE: 儲存個人優惠券明細
         * @return {Boolean}
         */
        async setUserCoupons(context, coupon) {
            context.commit(SETCOUPONS, coupon)
        },
        /**
         * NOTE: 修改個人優惠券明細
         * @return {Boolean}
         */
        async updUserCoupons(context, coupon) {
            context.commit(UPDCOUPONS, coupon)
        },
        /**
         * 取得個人推薦碼
         */
        async getReferralInfo(context) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.getReferralInfo(context.state.tokens).then(res => {
                    context.commit(SETREFEFFALINFO, res)
                    context.dispatch('saveState') // 存到localstorage
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * 兌換個人推薦碼
         */
        async applyReferralCode(context, code) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.applyReferralCode(context.state.tokens, code).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * 取得快速登入Code
         */
        async getCode(context) {
            // 檢查是否需要重置AccessToken
            await context.dispatch('refreshAccessToken')
            return new Promise((resolve, reject) => {
                api.coreApi.getCode(context.state.tokens).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        /**
         * 帳密登入
         */
        async accLogin(context, item) {
            return new Promise((resolve) => {
                api.coreApi.accLogin(item).then(res => {
                    let tokens = {
                        id_token: res.id_token,
                        access_token: res.access_token,
                        expires_in: res.expires_in,
                        token_type: res.token_type
                    }
                    let tokenJWT = jsFn.jwtDecode(res.id_token)
                    let info = {
                        id: tokenJWT.sub,
                        name: tokenJWT.name,
                        picture: tokenJWT.picture
                    }
                    // 檢查活動完成資訊是否需要重置                    
                    if(info.id !== context.state.userInfo.id) {
                        context.commit(RESBENEFITS)
                    }
                    context.commit(SETTOKEN, tokens)
                    context.commit(SETUSERINFO, info)
                    context.dispatch('saveState') // 存到localstorage
                    resolve(true)
                }).catch(() => {
                    resolve(false)
                })
            })
        },
        /**
         * 檢查是否需要重置AccessToken
         */
        async refreshAccessToken(context) {
            var nowTime = new Date()
            let cT = Date.parse(nowTime)
            let eT = Date.parse(context.state.tokens.expires_in)
            let oT = 0
            let btw = eT - oT - cT
            if (btw < 10 * 60 * 1000) {
                await api.coreApi.refreshToken(context.state.tokens.access_token).then(res => {
                    let newTokens = context.state.tokens
                    newTokens.access_token = res.access_token
                    newTokens.expires_in = res.expires_in
                    newTokens.token_type = res.token_type
                    context.commit(SETTOKEN, newTokens)
                    context.dispatch('saveState') // 存到localstorage
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        /**
         * 重置State
         */
        async resetState(context) {          
            localStorage.removeItem('coreData')  
            context.commit(RESETSTATE)
        },
        /** 
         * NOTE: 維持 vuex state 的資訊
        */
        keepState(context) {
            if(!jsFn.IsEmpty(localStorage.getItem('coreData'))) {
                let data = JSON.parse(decodeURIComponent(localStorage.getItem('coreData'),'utf-8'))
                context.commit(KEEPSTORAGE, data)
            }
        },
        /** 
        * NOTE: 儲存現在 state 的資訊
        */
        saveState(context) {
            localStorage.setItem('coreData', encodeURIComponent(JSON.stringify(context.state), 'utf-8'))
        }
    }
}
